export default "<button class=\"btn btn-att py-0 px-2\" [disabled]=\"disabled\">\n  <ng-content>\n\n  </ng-content>\n</button>\n";